import { Box, Flex } from "@chakra-ui/react";
import { RegraReservaComponentProps } from "..";
import { useRef } from "react";
import { LimitesReservaPeriodo } from "core/features/area-comum/typings/index";
import LimitesReservaPeriodoItem from "./LimitesReservaPeriodoItem";
import OutlineButton from "components/Button/OutlineButton";

export default function LimiteReservaPeriodo({
  control,
  watch,
  setValue,
}: RegraReservaComponentProps) {
  const tempIdIncrement = useRef(0);

  const limitesReservaPeriodo = watch("limitesReservaPeriodo");
  return (
    <Flex flexDir="column" mb="16px">
      <Box w="full">
        <Flex flexDir="column" gap={2}>
          {limitesReservaPeriodo?.map(
            (limites: LimitesReservaPeriodo, index: number) => (
              <LimitesReservaPeriodoItem
                setValue={setValue!}
                limites={limitesReservaPeriodo}
                key={limites.added ? limites.tempId : limites.id}
                index={index}
                control={control}
                showLabel={index === 0}
              />
            )
          )}
        </Flex>
      </Box>

      {!limitesReservaPeriodo || limitesReservaPeriodo?.length < 6 ? (
        <Flex align="center" mt={"16px"}>
          <OutlineButton
            onClick={() => {
              setValue!("limitesReservaPeriodo", [
                ...(limitesReservaPeriodo ?? []),
                {
                  added: true,
                  tempId: `${new Date().getTime().toString()}${
                    tempIdIncrement.current
                  }`,
                  limite: undefined,
                  tipoIntervaloPeriodoLimite: undefined,
                } as LimitesReservaPeriodo,
              ]);

              tempIdIncrement.current += 1;
            }}
          >
            Adicionar mais um parâmetro
          </OutlineButton>
        </Flex>
      ) : null}
    </Flex>
  );
}
